<mat-card class="add-employee-form" [formGroup]="form">
	<mat-card-title id="ADD_NEW_EMPLOYEE">Enter Employee Information</mat-card-title>
	<hr />
	<mat-card-content class="card-content">
		<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
			<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
				<input
					required
					formControlName="firstName"
					matInput
					placeholder="First Name"
					id="EMP_First_NAME"
					name="firstName"
					maxLength="100"
					#characterCountHintExample
				/>
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
			<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
				<input
					name="lastName"
					formControlName="lastName"
					id="EMP_Last_Name"
					required
					matInput
					placeholder="Last Name"
					maxLength="100"
					#characterCountHintExample
				/>
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
			<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
				<input
					name="email"
					formControlName="email"
					id="EMP_Email"
					required
					matInput
					placeholder="Email"
					maxLength="100"
					#characterCountHintExample
				/>
				<mat-error *ngIf="form.get('email')?.hasError('invalidEmail')">
					Invalid email format
				</mat-error>
				<mat-error *ngIf="form.get('email')?.hasError('invalidDomain')">
					Email domain must be one of: {{ form.get('email')?.getError('invalidDomain')?.allowedDomains?.join(', ') }}
				</mat-error>
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
			<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
				<input
					name="phoneNumber"
					formControlName="phoneNumber"
					id="EMP_Phone_Num"
					matInput
					placeholder="Phone Number"
					maxLength="12"
					#characterCountHintExample
				/>
			</mat-form-field>
			<mat-checkbox formControlName="phoneStipend" class="optional-column" [checked]="false"
				>Phone Stipend</mat-checkbox
			>
		</div>
		<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
			<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
				<input
					name="payrollNumber"
					formControlName="payrollNumber"
					id="EMP_Payroll_Num"
					required
					matInput
					placeholder="Payroll Number"
					maxLength="100"
					#characterCountHintExample
				/>
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
			<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
				<input
					name="workdayNumber"
					formControlName="workdayNumber"
					id="EMP_Workday_Num"
					required
					matInput
					placeholder="Workday Number"
					maxLength="100"
					#characterCountHintExample
				/>
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
			<mat-form-field class="input-full-width">
				<mat-select placeholder="Job Title" required formControlName="jobTitle">
					<mat-option *ngFor="let item of jobTitles" [value]="item.jobTitleId">
						{{ item.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
			<mat-form-field class="input-full-width">
				<mat-select placeholder="Aircraft Model" required formControlName="aircraftModel">
					<mat-option *ngFor="let item of aircraftModels" [value]="item.aircraftModelId">
						{{ item.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start center" class="mb-2">
			<mat-form-field appearance="fill">
				<mat-label>Hire Date</mat-label>
				<input formControlName="hireDate" required matInput [matDatepicker]="picker" />
				<mat-hint>MM/DD/YYYY</mat-hint>
				<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-datepicker #picker></mat-datepicker>
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="end end">
			<button
				class="form-button mr-2"
				color="primary"
				mat-raised-button
				[disabled]="form.invalid || form.pristine"
				(click)="addEmployee()"
			>
				Add New Employee
			</button>
		</div>
	</mat-card-content>
</mat-card>
